// Cypress Bend Leatherworks — Theme JS
// Cart count update
document.addEventListener('DOMContentLoaded', function() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      var badge = document.querySelector('.cart-badge');
      if (badge) badge.textContent = cart.item_count;
    });
});
